import moment from "moment";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import "./printRepair.scss";

const PrintRepair = () => {
    // let { state } = useLocation();
    // const repair = state[0];
    // const user = state[1];
    const { id } = useParams();

    const { data: repair, refetch: refetchRepair, isSuccess } = useGetPageQuery("repairs/" + id);
    const { data: user } = useGetPageQuery("users/" + repair?.user_id, { skip: !isSuccess });

    return (
        <>
            <style>
                {`
          @media print {
            @page {
              size: A4 portrait;
            }
            .print-scope {
              width: 210mm;
              height: auto;
              overflow: hidden;
              background: white;
              margin: 0;
              padding: 0;
            }
          }
        `}
            </style>
            {repair && user && (
                <div className="globalWrapper">
                    <div className="printWrapper">
                        <div className="title">
                            <div className="info_left">
                                <h2>{repair?.store?.title}</h2>
                                <p>{repair?.store?.address}</p>
                                <p>Тел.:&nbsp;{repair?.store?.phones}</p>
                                <p>Режим роботи: {repair?.store?.worktime}</p>&nbsp;
                            </div>
                            <div className="info_right text-right">
                                <div className="repair_num">Ремонт #{repair.id}</div>
                                <div className="qrcode">
                                    <QRCode
                                        value={repair.id}
                                        size={100}
                                    />
                                </div>
                                <div className="id_key">{repair.id}</div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                        <div className="infos">
                            <div className="info_left">
                                <p>
                                    <b>Клієнт:</b> {repair.client_name},&nbsp;{repair.client_phone}
                                </p>
                                <p>
                                    <b>Пристрій:</b> {repair.device}
                                </p>
                                <p>
                                    <b>Код розблокування:</b> {repair.pincode ? repair.pincode : "-"}
                                </p>
                                <p>
                                    <b>Серійний номер:</b> {repair.imei}
                                </p>
                                <p>
                                    <b>Комплектація:</b> {repair.assembly}
                                </p>
                                <p>
                                    <b>Вигляд:</b> {repair.view}
                                </p>
                                <p>
                                    <b>Несправність:</b> {repair.note_master}
                                </p>
                            </div>
                            <div className="info_right">
                                <p contenteditable="true">
                                    <b>Дата оформлення:</b>&nbsp;
                                    {moment(repair.created_at).format("DD.MM.YYYY HH:MM")}
                                </p>
                                <p contenteditable="true">
                                    <b>Закінчення ремонту:</b>&nbsp;---
                                </p>
                                <p>
                                    <b>Вартість ремонту:</b> {repair.price} грн.
                                </p>
                                <p>
                                    <b>Примітка:</b>
                                    {repair.note_client}
                                </p>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                        <div className="rules">
                            <p>
                                1.&nbsp;Сервісний центр не несе відповідальності за можливу втрату даних, що зберігались
                                в пам'яті пристрою, а також за залишені SIM&nbsp;та&nbsp;FLASH&nbsp;карти. Радимо
                                заздалегідь зробити резервну копію інформації.
                            </p>
                            <p>
                                2. У випадку порушень користувачем умов експлуатації, наявності слідів попадання рідини,
                                наявності слідів некваліфікованого ремонту, або будь-яких механічних пошкоджень,
                                замовник приймає на себе відповідальність за часткову чи повну втрату працездатності
                                пристрою в процесі ремонту.
                            </p>
                            <p>
                                3. Гарантія не розповсюджується та не продовжується на пристрої, що були відновлені
                                після попадання рідини.
                            </p>
                            <p>
                                4. Пристрій зберігаєтья в сервісному центрі 30 днів з моменту готовності. Після
                                закінчення цього терміну пристрій утилізується, а скарги по ньому не приймаються.
                            </p>
                            <p>
                                5. У випадку втрати квитанції на ремонт, пристрій може бути виданий після пред'явлення
                                паспорта, що засвідчує особу замовника.
                            </p>
                        </div>
                        <div
                            className="ski_client"
                            contenteditable="true"
                        >
                            Менеджер:&nbsp;_____________________&nbsp;{user.name}
                        </div>
                        <div
                            className="ski_compat"
                            contenteditable="true"
                        >
                            _____________________&nbsp;{repair.client_name} <br />з умовами ремонту ознайомився та
                            згідний
                        </div>
                        &nbsp;
                        <div className="clearfix"></div>
                        <div className="clip_pro">
                            _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
                            _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
                        </div>
                        <div className="title">
                            <div className="info_left">
                                <h2>{repair?.store?.title}</h2>
                                <p>{repair?.store?.address}</p>
                                <p>Тел.:&nbsp;{repair?.store?.phones}</p>
                                <p>Режим роботи: {repair?.store?.worktime}</p>&nbsp;
                            </div>
                            <div className="info_right text-right">
                                <div className="repair_num">Ремонт #{repair.id}</div>
                                <div className="qrcode">
                                    <QRCode
                                        value={repair.id}
                                        size={100}
                                    />
                                </div>
                                <div className="id_key">{repair.id}</div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                        <div className="infos">
                            <div className="info_left">
                                <p>
                                    <b>Клієнт:</b> {repair.client_name},&nbsp;{repair.client_phone}
                                </p>
                                <p>
                                    <b>Пристрій:</b> {repair.device}
                                </p>
                                <p>
                                    <b>Код розблокування:</b> {repair.pincode ? repair.pincode : "-"}
                                </p>
                                <p>
                                    <b>Серійний номер:</b> {repair.imei}
                                </p>
                                <p>
                                    <b>Комплектація:</b> {repair.assembly}
                                </p>
                                <p>
                                    <b>Вигляд:</b> {repair.view}
                                </p>
                                <p>
                                    <b>Несправність:</b> {repair.noteMaster}
                                </p>
                            </div>
                            <div className="info_right">
                                <p contenteditable="true">
                                    <b>Дата оформлення:</b>&nbsp;
                                    {moment(repair.created_at).format("DD.MM.YYYY HH:MM")}
                                </p>
                                <p contenteditable="true">
                                    <b>Закінчення ремонту:</b>&nbsp;---
                                </p>
                                <p>
                                    <b>Вартість ремонту:</b> {repair.price} грн.
                                </p>
                                <p>
                                    <b>Примітка:</b>
                                    {repair.note_client}
                                </p>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                        <div className="rules">
                            <p>
                                1.&nbsp;Сервісний центр не несе відповідальності за можливу втрату даних, що зберігались
                                в пам'яті пристрою, а також за залишені SIM&nbsp;та&nbsp;FLASH&nbsp;карти. Радимо
                                заздалегідь зробити резервну копію інформації.
                            </p>
                            <p>
                                2. У випадку порушень користувачем умов експлуатації, наявності слідів попадання рідини,
                                наявності слідів некваліфікованого ремонту, або будь-яких механічних пошкоджень,
                                замовник приймає на себе відповідальність за часткову чи повну втрату працездатності
                                пристрою в процесі ремонту.
                            </p>
                            <p>
                                3. Гарантія не розповсюджується та не продовжується на пристрої, що були відновлені
                                після попадання рідини.
                            </p>
                            <p>
                                4. Пристрій зберігаєтья в сервісному центрі 30 днів з моменту готовності. Після
                                закінчення цього терміну пристрій утилізується, а скарги по ньому не приймаються.
                            </p>
                            <p>
                                5. У випадку втрати квитанції на ремонт, пристрій може бути виданий після пред'явлення
                                паспорта, що засвідчує особу замовника.
                            </p>
                        </div>
                        <div
                            className="ski_client"
                            contenteditable="true"
                        >
                            Менеджер:&nbsp;_____________________&nbsp;{user.name}
                        </div>
                        <div
                            className="ski_compat"
                            contenteditable="true"
                        >
                            _____________________&nbsp;{repair.client_name} <br />з умовами ремонту ознайомився та
                            згідний
                        </div>
                        &nbsp;
                        <div className="clearfix"></div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PrintRepair;
